import type { PropsWithChildren, ReactNode } from 'react';

import { Actionable, Text, Tooltip } from 'reshaped';
import type { TooltipProps } from 'reshaped';

type EvenTooltipProps = PropsWithChildren<{
  position?: TooltipProps['position'];
  text: string | ReactNode;
}>;

export const EvenTooltip = (props: EvenTooltipProps) => {
  const { text, position = 'end', children } = props;

  // the tooltip can be passed children to be rendered or explicit text to render via the text prop
  const tooltipContent =
    typeof text === 'string' ? <Text variant="body-1">{text}</Text> : text;

  return (
    <Tooltip position={position} text={tooltipContent}>
      {(attributes) => (
        <Actionable as="div" attributes={attributes}>
          {children}
        </Actionable>
      )}
    </Tooltip>
  );
};
